import {Button} from "@/components/atoms/button";
import {Link} from "@/components/atoms/link";
import dynamic from "next/dynamic";
import {getParagraphSections} from "@/lib/get-paragraph-sections";
import SectionHeading from "@/components/organisms/section-heading";
import {RenderSections} from "@/components/templates/sections/section-regions";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";
const ArticleSlider = dynamic(() => import("../../../organisms/slider").then((mod) => mod.ArticleSlider));
const FormattedText = dynamic(() => import("../../../formatted-text").then((mod) => mod.FormattedText));

/**
 * The Event output for the Event, should be imported using dynamic().
 * @param node
 * @param additionalContent
 * @param layout
 * @param props
 * @constructor
 */
export function ContentEvent({ node, additionalContent, layout, ...props }) {
  const {sections, sectionMap} = getParagraphSections(layout);

  return (
    <>
      {(node?.field_event_intro_title || node?.field_event_intro_text?.processed) && (
        <div id="event-header" className="container mx-auto px-6 lg:px-0 mt-24 scroll-m-40">
          <SectionHeading title={node?.field_event_intro_title ?? ""}>
            {node?.field_event_intro_text?.processed && (
              <FormattedText processed={node.field_event_intro_text.processed}/>
            )}
          </SectionHeading>
        </div>
      )}
      {node.body?.processed && (
        <div className="container mx-auto px-6 lg:px-0 mt-12">
          <div className="prose">
            <FormattedText processed={node.body.processed}/>
          </div>
        </div>
      )}
      {sections?.length ? (
        <div className="mt-20">
          <RenderSections sections={sections} sectionMap={sectionMap}/>
        </div>
      ): <></>}
    </>
  );
}

/**
 * The lower Event content output for Event, this component should be loaded in using dynamic().
 *
 * @param node
 * @param date
 * @param additionalContent
 * @param props
 * @constructor
 */
export function ContentEventLower({ node, additionalContent, ...props }) {
  const t = useContext<Dictionary>(DictionaryContext);

  return (
    <>
      <div className="container mx-auto px-6 lg:px-0">
        {node?.type === "node--article" && (
          <Button href={"/news"} color="black" hover={{color: "black"}} invertColor={"black"} invert={true} className="!border-gray-300" icon="arrow-right">{`${t?.all?.back_to_news}`}</Button>
        )}
      </div>
      {additionalContent?.relatedNews?.length ? (
        <div className="container px-6 py-24 mx-auto">
          <div className={"mb-6"}>
            <h2 className="!text-gray-800 inline font-semibold mb-2 md:!text-4xl">
              {`${t?.all?.related_news}`}
            </h2>
            {/* @todo localize and fix this link */}
            <Link href={"/news"} className="text-primary inline pl-6">{`${t?.all?.see_all_news}`}<span>&#8594;</span></Link>
          </div>
          <ArticleSlider articles={additionalContent?.relatedNews}/>
        </div>
      ) : <></>}
    </>
  );
}
